import { defineComponent, Types } from 'bitecs';

/**
 * Component for entities that should be rendered visually.
 */
export const Renderable = defineComponent({
    texture: Types.ui32, // Reference to texture ID or asset key
    scale: Types.f32,    // Optional scale factor (default 1.0)
    // Add other potential rendering properties here if needed, e.g.:
    // tint: Types.ui32,   // Color tint
    // visible: Types.ui8 // Visibility flag
});

// Initialize default scale if needed, although bitecs might handle defaults
// Renderable.scale.set(1.0); // Check bitecs documentation for default values 